export default __webpack_public_path__ + "static/media/Empresas de investimento.9c8cb073.png";